export default {
  THIS_FEATURE_HAS_BEEN_SHOWN: "thisFeatureHasBeenShown",
}